











import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import BaseIcon from 'vuecomponents/base_icon.vue'

@Component({
  components: { BaseIcon },
})
class SurfacePostCommentsIcon extends Vue {
  @Prop() commentIds!: [string | number]

  get commentsListLength() {
    return this.commentIds.length
  }

  showCommentsPanel() {
    this.$emit('show-comments-panel')
  }
}
export default SurfacePostCommentsIcon
